import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import DealInputFields from '../../components/deals/dealInputFields'
import * as actions from './actions'
import { routePrefix } from '../../config';
import './styles.css'
import { DEAL_TYES_ALL_ROUTES } from '../../utils/constants';
import { dealSelected, disableBodyScrolling } from '../../utils';
import { opdbGTM } from '../../utils/pulseUtils';
import Card from "../../Card";
import dealBackIcon from '../../../src/images/dealBackIcon.svg'
import { Link } from 'react-router-dom'

const allDays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];


class CreateEditDeal extends React.Component {

  constructor(props) {
    super(props);

    let isEditCase = false;
    if(props.match.params.dealId) {
      isEditCase = true;
    }

    this.state = {
      focusedStartDate: null,
      focusedEndDate: null,
      focusedExcluedDate: null,
      dealName: '',
      startDate: null,
      endDate: null,
      excludeDate: null,
      discountValue: '',
      discountType: 'FLAT',//'-1'
      minSeatFare: '',
      maxSeatFare: '',
      applicableDays: ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'],
      source: null,
      destination: null,
      selectedServices: [],
      maxDiscountValue:'',
      isDataFetched: false,
      isEditCase,
      isRoutesPopulated: false,
      excludedDatesArr: [],
      dealType: '-1',
      isAllServicesSelected: true,
      isAllRoutesSelected: true,
      // earlyBirdThresholdDays: '',
      earlyBirdNumOfSeats: '',
      servicesObj: {},
      journeyDate: null,
      focusedJourneyDate: false,
      selectedSeats:[],
      dealStartTimeInHours: '-1',
      startDealOccupancyThreshold: '',
      stopDealOccupancyThreshold: '',
      showViaRoutesWindow: false,
      selectedRoute: null,
      currentViaRoutes: [],
      selectedServiceRouteName: '',
      selectedServiceTime:'',
      selectedServiceBusType:'',
      inventoryRefreshCheckbox: false,
      isDealSelected: false,
      dealValue: '',
      dealKey: '',
      updateDealType: '',
      seatSelected: [],
      returnTripServicesList: []
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    // in case of edit prefill the state data
    if(prevState.isEditCase && !prevState.isDataFetched && nextProps.dealData) {
      const deal = nextProps.dealData;
      return {
        dealName: deal.display_text,
        dealType: deal.deal_type,
        selectedServices: deal.service_ids || [],
        startDate: moment(deal.start_date),
        endDate: moment(deal.end_date),
        discountType: deal.discount_type,
        discountValue: +deal.discount_value || 0,
        applicableDays: deal.applicable_days? deal.applicable_days.map(el => el.toLowerCase()):
          ['monday','tuesday','wednesday','thursday','friday','saturday','sunday'],
        excludedDatesArr: deal.excluded_dates || [],
        minSeatFare: +deal.min_seat_fare || 1,
        maxSeatFare: +deal.max_seat_fare || 100000,
        maxDiscountValue: +deal.max_discount_value || 0,
        isDataFetched: true,
        // earlyBirdThresholdDays: +deal.early_bird_threshold_days || 0,
        earlyBirdNumOfSeats: +deal.early_bird_threshold_num_of_seats || 0,
        isAllServicesSelected: false,
        paytm_route: deal.paytm_route,
        dealStartTimeInHours: deal.last_minute_threshold_hours,
        isAllRoutesSelected: (deal && deal.service_ids && deal.service_ids.length > 0 && deal.service_ids[0] === 'ALL') ? true : false,
        startDealOccupancyThreshold: deal.seat_occupancy_threshold && Number(deal.seat_occupancy_threshold.split("-")[0]),
        stopDealOccupancyThreshold: deal.seat_occupancy_threshold && Number(deal.seat_occupancy_threshold.split("-")[1])
      }
    }
    if(!prevState.isRoutesPopulated && nextProps.metaDetails.paytm_src_id && nextProps.dealData && nextProps.dealData.paytm_route) {
      // const [sourceId, destId] = nextProps.dealData.paytm_route.split('-'); //nextProps.dealData.route_id.split('-');
      // const obj = {};
      // set the source and destination object from operator routes
      // nextProps.operatorRoutes.forEach(el => {
      //   if(el.id == sourceId) obj.source = { name: el.name, city_id: el.id } ;
      //   if(el.id == destId) obj.destination = { name: el.name, city_id: el.id };
      // });
      // obj.isRoutesPopulated = true;
      // return obj;
      return {
        source: {
          name: nextProps.metaDetails.source,
          city_id: nextProps.metaDetails.paytm_src_id
        },
        destination: {
          name: nextProps.metaDetails.destination,
          city_id: nextProps.metaDetails.paytm_dest_id
        },
        isRoutesPopulated: true
      }
    }
    return null;
  }

  componentDidMount() {
    const savedDealSelected = dealSelected.get() || {};

    if (savedDealSelected.isDealSelected != null && savedDealSelected.dealValue != null) {
      this.setState({
        isDealSelected:
          savedDealSelected.isDealSelected !== undefined
            ? savedDealSelected.isDealSelected
            : false,
        dealValue: savedDealSelected.dealValue !== undefined ? savedDealSelected.dealValue : "",
        dealKey: savedDealSelected.dealKey !== undefined ? savedDealSelected.dealKey : "",
      });
    }
    document.title = 'Operator Deals';
    this.date = moment().format('DD-MMM-YYYY');
    if(this.state.isEditCase) {
      this.props.fetchDealData(this.props.match.params.dealId, true);

      const seatDataString = localStorage.getItem('seat_selected');
      let seatData = seatDataString ? JSON.parse(seatDataString) : [];
      if(seatData && seatData.length > 0) {
        this.setState({seatSelected: seatData});
      }
      // this.props.getOperatorRoutes();
    }

    this.props.fetchDealList();
  }

  componentWillUnmount() {
    this.props.clearDealData();
  }

  onTabChange = (e) => {
    this.setState({
      activeTab: e.target.id
    })
  }

  getIntermediateRoutes = (id) => {
    const { routeServices } = this.props;
    let selectedServiceRoutes;
    let viaRoutes = [];
    routeServices.map((service) => {
      if(service.id === id){
        selectedServiceRoutes = service.via_routes;
        this.setState({selectedServiceRouteName : service.route_name, selectedServiceTime : service.departure_datetime, selectedServiceBusType : service.bus_type_name})
      }
    })
    selectedServiceRoutes && selectedServiceRoutes.map((route) => {
      viaRoutes.push(route.route_name)
    })
    this.setState({currentViaRoutes : viaRoutes})
  }

  setReturnTripServicesList = (returnTripDeal) => {
    const services = returnTripDeal.filter(service => service.isSelected).flatMap(service => service.servicesList);
    this.setState({ returnTripServicesList: [...services]});
  }

  prepareRoutesData = (selectedServices, isAllRoutesSelected) => {
    const { routeServices, servicesDataList } = this.props;

    // const filteredData = routeServices.filter(item => selectedServices.includes(item.id));
     let dataList = servicesDataList || routeServices;
     if(this.state.dealKey === 'RETURN_TRIP') {
      dataList = this.state.returnTripServicesList;
     }
    const transformedPayload = isAllRoutesSelected ? [{
      "paytm_route": "*-*",
      "provider_route": "*-*",
      services: []
    }]: dataList.reduce((result, elem) => {
      const key = `${elem.route}-${elem.route}`;
      
      if (!result[key]) {
          result[key] = {
              paytm_route: elem.route,
              provider_route: elem.route,
              services: [],
          };
      }
      
      result[key].services.push({
          service_id: elem.id,
          via_routes: (elem.via_routes || []).map((data) => ({
              route: data.route,
              route_name: data.route_name,
          })),
          seats_selected: (this.state.dealKey ===  'SEAT_LEVEL' || this.state.dealType === 'SEAT_LEVEL') ? this.props.dynamicSeatData[elem.id] : '',

      });
      
      return result;
  }, {});
      return isAllRoutesSelected ? transformedPayload : Object.values(transformedPayload);
  }

  setShowViaRoutesWindow = (isOpen, id) => {
    if(isOpen){
      disableBodyScrolling(isOpen);
      this.setState({
        showViaRoutesWindow: true,
        selectedRoute: id
      })
      this.getIntermediateRoutes(id);
  }
  else{
    disableBodyScrolling(isOpen);
    this.setState({
      showViaRoutesWindow: false
    })
  }
  }

  

  onInputFieldChange = (value, name) => {
    const cleanedValue = value.replace(/-/g, '');
    this.setState({ [name]: cleanedValue })
  }

  onStartFocusChange = ({ focused }) => this.setState({ focusedStartDate: focused })

  onEndFocusChange = ({ focused }) => this.setState({ focusedEndDate: focused })

  onStartDateChange = date => this.setState({ startDate: date, excludedDatesArr: [] })

  onJourneyDateChange = date => this.setState({ journeyDate: date })

  onJourneyDateFocusChange = ({ focused }) => this.setState({ focusedJourneyDate: focused })

  onEndDateChange = date => {
    if(!date) return;
    date = date.set({ 'hour': 23, 'minute': 59, 'second': 59 })
    this.setState({ endDate: date, excludedDatesArr: [] });
  }

  onDiscountTypeChange = event => {
    let value = event.target.value;
    this.setState({
      discountType: event.target.value,
      maxDiscountValue: value === 'FLAT'? '': this.state.maxDiscountValue
    })
  }

  onDealTypeChange = event => {
    const { value } = event;
    let obj = { dealType: value }
    if(value === 'SEAT_LEVEL')
      obj.isAllServicesSelected = false;
    else
      obj.isAllServicesSelected = true;
    this.setState(obj)
  }

  onDealStartTimeInHoursChange = event => {
    this.setState({ dealStartTimeInHours: Number(event.target.value) })}

  onExcludedFocusChange = ({ focused }) => this.setState({ focusedExcluedDate: focused })

  onExcludedDateChange = date => {
    if(!this.state.startDate || !this.state.endDate) {
      alert('Kindly select start date and end date first.');
      return;
    }

    if(this.state.excludedDatesArr.includes(date.format('YYYY-MM-DD'))) return;

    this.setState(prevState => ({
      excludedDatesArr: prevState.excludedDatesArr.concat(date.format('YYYY-MM-DD')),
    }))
  }

  startDateRangeChecker = (date) => moment().diff(date) > 0 || date.isAfter(this.state.endDate)

  endDateRangeChecker = (date) => moment().diff(date) > 0 || date.isBefore(this.state.startDate)

  excludeDateRangeChecker = (date) => date.isAfter(this.state.endDate) || date.isBefore(this.state.startDate)

  journeyDateRangeChecker = (date) => moment().diff(date) > 0

  onRemoveExculdedDate = date => {
    this.setState(prevState => ({
      excludedDatesArr: prevState.excludedDatesArr.filter(el => el !== date)
    }))
  }

  onDayChange = (value) => this.setState({ period: value })

  onApplicableDaysChange = (day, isChecked) => {
    this.setState(prevState => ({
      applicableDays: isChecked?
        prevState.applicableDays.concat(day)
        : prevState.applicableDays.filter(el => el !== day)
    }))
  }

  fetchCities = (value, fieldType) => {
    this.props.fetchCities(value, fieldType);
  }

  onDestinationInputChange = () => {

  }

  onSourceItemSelect = (item) => {
    this.setState({ source: item })
  }

  onDestinationItemSelect = (item) => {
    this.setState({ destination: item })
  }

  onServiceOptionChange = (label, isChecked) => {
    this.setState({
      isAllServicesSelected: label === 'Selected Service'? !isChecked: isChecked,
      selectedServices: []
    })
  }

  onAllRoutesSelectionChange = (label, isChecked) => {
    this.setState({
      isAllRoutesSelected: label === 'Selected Routes'? !isChecked: isChecked
    })
  }


  onSearchClick = (returnTripDeal = false, returnTripDealCity = null, isReverseRouteClicked = false, addReturnTripDeal) => {
    let { source, destination, journeyDate,  inventoryRefreshCheckbox} = this.state;
    if(returnTripDeal && isReverseRouteClicked && returnTripDealCity) {
      source = returnTripDealCity.source;
      destination = returnTripDealCity.destination;
    }
    else if(returnTripDeal) {
      let temp = source;
      source = destination;
      destination = temp;
    }
 
    if(!source || !destination) {
      alert('Please select a valid value of source and destination.');
      return;
    }
    const merchantId = localStorage.getItem('merchant-id');
    this.props.fetchServices({
      paytm_src_id: source.city_id + '',
      paytm_dest_id: destination.city_id + '',
      is_round_trip: false,
      include_via_routes: inventoryRefreshCheckbox,
      // journey_date: journeyDate? journeyDate.format('YYYY-MM-DD'): undefined
    }, merchantId, addReturnTripDeal, isReverseRouteClicked
  );
    localStorage.setItem('source', JSON.stringify(source));
    localStorage.setItem('destination', JSON.stringify(destination));
    opdbGTM.dealsSrcSearchClicked(source, destination, inventoryRefreshCheckbox);
  }

  onSearvicesSelection = (routeTimeId, isChecked, dealType, serviceData) => {
    if (dealType !== "SEAT_LEVEL"){
      this.setState(prevState => ({
        selectedServices: isChecked ?
          prevState.selectedServices.concat(routeTimeId)
          : prevState.selectedServices.filter(el => el != routeTimeId)
      }))
    } else {
      const source = localStorage.getItem('source') || '{}';
      const destination = localStorage.getItem('destination') || '{}';

      const sourceData = JSON.parse(source);
      const destData = JSON.parse(destination);

        const mockDetails = {
          ...(this.props.metaDetails || {}),
          paytm_src_id: sourceData.city_id || '',
          paytm_dest_id: destData.city_id || '',
        };
  
      this.setState({ selectedServices: [routeTimeId] });
      this.props.fetchSeatLayout(serviceData, mockDetails);
    }
  }

  selectAllClicked = (routes) => {
    let ids = [];
    routes.map((el, index) => {
      ids.push(el.id)
    })
    this.setState({selectedServices : ids})
}

clearAllClicked = () => {
  let ids = [];
  this.setState({selectedServices : ids})
}

setDealSelected = (event, value, type) => {
  const { isDealSelected } = this.state;
  this.setState({isDealSelected : !isDealSelected});
  dealSelected.set(!isDealSelected, value, type);
  this.onDealTypeChange(event);
  this.setState({dealValue : value});
  this.setState({dealType : event});

  const element = document.getElementById('route-pages');
  if (element) {
    element.scrollTo(0, 0);
  }
}

setDealType = (element) => {
  this.setState({dealKey: element.type});
}

  onInventoryRefreshCheckBox = () => this.setState({ inventoryRefreshCheckbox: !this.state.inventoryRefreshCheckbox })

  selectSeatHandler=(seat) => {

    if(!seat.is_reserved_for_ladies && !seat.is_available) {
      return;
    }
    
    if(!this.state.isEditCase) {
      const seatStringify = JSON.stringify(seat);
      const { selectedSeats } = this.state;
      let seatIndex = -1;
      seatIndex = selectedSeats.indexOf(seatStringify);
      const seatDataString = localStorage.getItem('seat_selected');
      let seatData = seatDataString ? JSON.parse(seatDataString) : [];
      let seatDataIndex = seatData.indexOf(seatStringify) || 0;
      if (seatIndex === -1) {
        selectedSeats.push(JSON.stringify(seat));
      } else if (seatIndex !== -1) {
        selectedSeats.splice(seatIndex, 1);
        if(seatDataIndex > 0) {
          seatData.splice(seatDataIndex, 1);
        }
      }
      const updatedSeat = [...selectedSeats];
      this.setState({ selectedSeats: updatedSeat });
      // this.setState({ seatSelected: [] });
    } else if(this.state.isEditCase) {

      const { seatSelected } = this.state;

      let seatStringify = [];
       seatStringify = JSON.stringify(seat);
      // const seatDataString = localStorage.getItem('seat_selected');
      // let seatData = seatDataString ? JSON.parse(seatDataString) : [];

      let seatIndex = -1;
      seatIndex = seatSelected.indexOf(seatStringify);
      if (seatIndex === -1) {
        seatSelected.push(seatStringify);
      } else if (seatIndex !== -1) {
        seatSelected.splice(seatIndex, 1);
      }

      // const priya = localStorage.getItem('seat_selected');
      // let priya1 = priya ? JSON.parse(priya) : [];
      const updatedSeat = [...seatSelected];

      this.setState({ seatSelected: updatedSeat });
    }
  }
  onCancelClick = () => {
    const isEditDealOngoingPage = localStorage.getItem('EDIT_DEAL_ONGOING_DEAL');
    if(isEditDealOngoingPage === 'true') {
      this.props.history.push(routePrefix + '/deals');
      return;
    }
    else {
      const newUrl = `${routePrefix}/deals/create`;
      window.location.href = newUrl;
    }  
  } 

  onViewDealsClick = () => {}

  createSeatsSelectedObj = (selectedSeats) => {
    let hashSetArray = selectedSeats.map((seat)=>{
      seat = JSON.parse(seat);
      return seat.seat_number+'';
    })
    return hashSetArray;
  }

  onCreateDealClick = () => {
    const {
      source,
      endDate,
      dealName,
      // dealType,
      startDate,
      minSeatFare,
      maxSeatFare,
      destination,
      discountType,
      discountValue,
      applicableDays,
      selectedServices,
      maxDiscountValue,
      excludedDatesArr,
      earlyBirdNumOfSeats,
      isAllServicesSelected,
      selectedSeats,
      // earlyBirdThresholdDays,
      dealStartTimeInHours,
      startDealOccupancyThreshold,
      stopDealOccupancyThreshold,
      isAllRoutesSelected,
      dealKey,
      // selectedSeats
    } = this.state;
    // const seatDataString = localStorage.getItem('seat_selected');
    // const seatData = seatDataString ? JSON.parse(seatDataString) : [];
    // let {selectedSeats} = this.state.isEditCase ? {selectedSeats :seatData} : this.state;
    const merchantId = localStorage.getItem('merchant-id');

    let selectedSeatsMap=null;
    if(dealKey == -1) {
      alert('Kindly select a valid value of deal type.');
      return;
    }
    if(discountType == -1) {
      alert('Kindly select a valid value of discount type.');
      return;
    }
    if(!dealKey === 'RETURN_TRIP' && !discountValue) {
      alert('Kindly enter a valid value of discount.');
      return;
    }
    if(discountType === 'PERCENT' && discountValue < 5) {
      alert('Minimum deal value allowed is 5%');
      return;
    }
    if(discountType === 'FLAT' && discountValue < 50) {
      alert('Minimum deal value allowed is Rs. 50');
      return;
    }
    if(discountType === 'PERCENT' && (+discountValue < 0 || +discountValue > 100)) {
      alert('Discount % should be in the range of 0 to 100.');
      return;
    }
    if(discountValue === '0') {
      alert('Discount value should be in the range of 0 to 100.');
      return;
    }
    if(!dealKey === 'RETURN_TRIP' && !minSeatFare) {
      alert('Kindly enter a valid minimum Seat Fare.');
      return;
    }
    if(minSeatFare === '0') {
      alert('minimum Seat Fare should be in the range of 0 to 100.');
      return;
    }
    if(maxSeatFare === '0') {
      alert('maximum Seat Fare should be in the range of 0 to 100.');
      return;
    }
    if(!dealKey === 'RETURN_TRIP' && !maxSeatFare) {
      alert('Kindly enter a valid maximum Seat Fare.');
      return;
    }
    if(minSeatFare && maxSeatFare && (+minSeatFare >= +maxSeatFare)) {
      alert('Min seat fare should be less than max seat fare.');
      return;
    }
  
    if(discountType === 'PERCENT' && maxDiscountValue === '0') {
      alert('maximum discount value should be in the range of 0 to 100.');
      return;
    }
    if(!dealKey === 'FEMALE_DEAL' && discountType === 'PERCENT' && !maxDiscountValue) {
      alert('Kindly enter the max discount value.');
      return;
    }
    if(!startDate) {
      alert('Kindly select the start date.');
      return;
    }
    if(!endDate) {
      alert('Kindly select the end date.');
      return;
    }
    if(maxSeatFare && maxDiscountValue && (+maxDiscountValue > +maxSeatFare)) {
      alert('Max discount value should be less than max seat fare.');
      return;
    }
    // if user is clicking create without source and destination
    if(!isAllRoutesSelected && (!source || !destination) && !this.state.isEditCase) {
      alert('Please select a valid value of source and destination.');
      return;
    }
    if(!isAllRoutesSelected && !isAllServicesSelected && !selectedServices.length) {
      alert('Kindly select the service.');
      return;
    }
    if(!isAllRoutesSelected && isAllServicesSelected && !this.props.routeServices.length) {
      alert('Kindly search and select the services.');
      return;
    }
    if (dealKey === "SEAT_LEVEL" && selectedSeats.length===0 ){
      alert('Kindly select the seats.');
      return;
    }
    if (dealKey === "SEAT_LEVEL"){
     selectedSeatsMap = this.createSeatsSelectedObj(selectedSeats);
    }
    if(dealKey === 'LAST_MINUTE' && dealStartTimeInHours === -1) {
      alert('Kindly select deal start time');
      return;
    }
    if(dealKey === 'LAST_MINUTE' && !startDealOccupancyThreshold) {
      alert('Kindly enter Start deal when occupancy is less than Y%');
      return;
    }
    if(dealKey === 'LAST_MINUTE' && !stopDealOccupancyThreshold) {
      alert('Kindly enter Stop deal when occupancy reaches Z%');
      return;
    }
    if(dealKey === 'LAST_MINUTE' && (startDealOccupancyThreshold <= 1 || startDealOccupancyThreshold >= 100)){
      alert('Start deal occupancy threshold should be between 1 - 100');
      return;
    }
    if(dealKey === 'LAST_MINUTE' && startDealOccupancyThreshold > stopDealOccupancyThreshold){
      alert('Start deal occupancy threshold cannot be more than stop deal occupancy threshold');
      return;
    }
    if(dealKey === 'EARLY_BIRD' && !earlyBirdNumOfSeats){
      alert('Kindly select number of seats');
      return;
    }
    
    if((dealKey ===  'SEAT_LEVEL' || this.state.dealType === 'SEAT_LEVEL') && this.state.isEditCase) {
      localStorage.setItem('seat_selected', JSON.stringify(this.state.seatSelected))
    }
    let obj = {
      deal_display_text: dealName,
      deal_type: dealKey === 'CUSTOM' ? 'FLAT_DEAL' : dealKey,
      // seats_selected: (dealKey ===  'SEAT_LEVEL' || this.state.dealType === 'SEAT_LEVEL') ? 
      //   this.state.isEditCase ? this.state.seatSelected :
      //   selectedSeatsMap || this.state.selectedSeats ||
      //  JSON.parse(localStorage.getItem('seat_selected'))  || this.props.seatSelected : '',
      discount_type: discountType,
      start_date: startDate.format('YYYY-MM-DD'),
      end_date: endDate.format('YYYY-MM-DD'),
      discount_value: +discountValue || 0,
      applicable_days: (applicableDays.length? applicableDays : allDays).map(el => el.toUpperCase()),
      excluded_dates: excludedDatesArr,
      min_seat_fare: +minSeatFare || (dealKey === 'RETURN_TRIP' ? -1: 1),
      max_seat_fare: +maxSeatFare || (dealKey === 'RETURN_TRIP' ? -1: 100000),
      max_discount_value: discountType === 'FLAT' ? +discountValue || 0 : +maxDiscountValue || 0,
      // service_ids: selectedServicesArr,
      // early_bird_threshold_days: +earlyBirdThresholdDays || 0,
      early_bird_threshold_num_of_seats: +earlyBirdNumOfSeats || 0,
      // paytm_route: isAllRoutesSelected ? '*-*' : source.city_id + '-' + destination.city_id,
      last_minute_threshold_hours: dealStartTimeInHours,
      seat_occupancy_threshold: startDealOccupancyThreshold && stopDealOccupancyThreshold ?
      `${startDealOccupancyThreshold.toString()}-${stopDealOccupancyThreshold.toString()}` : null,
      provider_route : '',
      route_services: this.prepareRoutesData(selectedServices, isAllRoutesSelected),
    }

    let service_ids = [], formattedSelectedServices = {}, minFare=Infinity;
    // format: formattedSelectedServices: { "provider_srcid-provider_dest": [route_time_ids] }
    // in case of all services, the ids of all the items
    // special case for deal_type=Flat and "all routes"
    if((DEAL_TYES_ALL_ROUTES.includes(this.state.dealKey || this.state.dealType)) && isAllRoutesSelected) {
      service_ids = ['ALL'];
      formattedSelectedServices = { '*-*': ['ALL'] };
      // obj.paytm_route = '*-*';
    }
    else if(isAllServicesSelected)  {
      if(dealKey === 'RETURN_TRIP') {
        obj.paytm_route = destination.city_id + '-' + source.city_id;
      }
      else {
        obj.paytm_route = source.city_id + '-' + destination.city_id;
      }
      this.props.routeServices.forEach(el => {
        if(this.state.isEditCase) service_ids.push(el.id);
        else {
          let key = el.route//el.provider_source_id + '-' + el.provider_destination_id;
          formattedSelectedServices[key] = (formattedSelectedServices[key] || []).concat(el.id);
        }
        // calculate min fare
        // if(el.fare && el.fare.length) {
        //   let temp = Infinity;
        //   el.fare.forEach(fare => fare.base_fare < temp? (temp = +fare.base_fare): '');
        //   minFare = minFare > temp? temp: minFare;
        // }
      })
    } 
    else if(!isAllServicesSelected && !this.state.isEditCase) {
      if(dealKey === 'RETURN_TRIP') {
        obj.paytm_route = destination.city_id + '-' + source.city_id;
      }
      else {
        obj.paytm_route = source.city_id + '-' + destination.city_id;
      }
      selectedServices.forEach(id => {
        let obj = this.props.routeServices.find(el => el.id == id);
        if(obj) {
          if(!this.state.isEditCase) {
            let key = obj.route//obj.provider_source_id + '-' + obj.provider_destination_id;
            formattedSelectedServices[key] = (formattedSelectedServices[key] || []).concat(id);
          }
          // calculate min fare
          // if(obj.fare && obj.fare.length) {
          //   let temp = Infinity;
          //   obj.fare.forEach(fare => fare.base_fare < temp? (temp = +fare.base_fare): '');
          //   minFare = minFare > temp? temp: minFare;
          // }
        }
      });
      service_ids = selectedServices;
    }
    // will be handled at server
    // if min fare of all the selected services is greater than max discount then throw error
    // if(discountType === 'FLAT' && minFare <= obj.max_discount_value) {
    //   let error = `${discountType !== 'FLAT'? 'Max d': 'D'}iscount value is greater than the min fare (${minFare}) of all selected services.`;
    //   alert(error);
    //   return;
    // }

    if(this.state.isEditCase) {
      let foundDealType = '';
      obj.service_ids = service_ids;
      obj = { ...this.props.dealData, ...obj };
      for (const dealType of DEAL_TYES_ALL_ROUTES) {
        if (obj.deal_id.includes(dealType)) {
            foundDealType = dealType;
            this.setState({updateDealType: foundDealType});
            break; // Exit the loop when a match is found
        }
    }
      obj.deal_type = foundDealType;
      this.props.updateDeal(obj, () => this.props.history.push(routePrefix + '/deals'));
    } else {
      const { metaDetails } = this.props;
      // obj.route_services = formattedSelectedServices;
      // let providerRoute = isAllRoutesSelected && dealKey !== "SEAT_LEVEL" ?  '*-*' : `${metaDetails.provider_src_id}-${metaDetails.provider_dest_id}`
      // obj.provider_route = providerRoute;
      localStorage.setItem('tab_selected', 'ongoing');
      this.props.createDeal(obj, merchantId, () => this.props.history.push(routePrefix + '/deals'));
    }
    opdbGTM.dealCreateClicked(dealKey, discountType, discountValue)
  }

  handleDealBackButtonClick = () => {
    dealSelected.set(false, '', '');
    this.setState({ isDealSelected : false });
    this.props.history.push(routePrefix + '/deals/create');
    window.location.reload();
  }


  render() {
    return (
      <div className="payout">
        <div className="row dealBackIcon">
        {!this.state.isEditCase && this.state.isDealSelected && (
         <Link to={routePrefix + '/deals/create'}>
           <img src={dealBackIcon} className='backArrow' alt='dealBackIcon' onClick={this.handleDealBackButtonClick}  />
         </Link>
         )}
        <p className="payout-header-deal">{this.state.isDealSelected ? `Create ${this.state.dealValue}`
         : this.state.isEditCase? 'Update': 'Create New'} {this.state.dealKey !== 'FEMALE_DEAL' ? 'Deal' : ''}</p>
        </div>
        {(!this.state.isDealSelected) && !this.state.isEditCase && <Card
        setDealSelected={this.setDealSelected}
        isEditCase={this.state.isEditCase} 
        setDealType={this.setDealType}
        />}
        {(this.state.isDealSelected || this.state.isEditCase)&& <DealInputFields
          dealType={this.state.dealKey || this.state.dealType}
          isEditCase={this.state.isEditCase}
          dealName={this.state.dealName}
          discountValue={this.state.discountValue}
          minSeatFare={this.state.minSeatFare}
          maxSeatFare={this.state.maxSeatFare}
          maxDiscountValue={this.state.maxDiscountValue}
          source={this.state.source}
          selectedServices={this.state.selectedServices}
          routeServices={this.props.routeServices}
          destination={this.state.destination}
          // operatorRoutes={this.props.operatorRoutes}
          applicableDays={this.state.applicableDays}
          startDate={this.state.startDate}
          endDate={this.state.endDate}
          journeyDate={this.state.journeyDate}
          isAllServicesSelected={this.state.isAllServicesSelected}
          isAllRoutesSelected={this.state.isAllRoutesSelected}
          excludedDatesArr={this.state.excludedDatesArr}
          discountType={this.state.discountType}
          focusedStartDate={this.state.focusedStartDate}
          focusedEndDate={this.state.focusedEndDate}
          focusedExcluedDate={this.state.focusedExcluedDate}
          focusedJourneyDate={this.state.focusedJourneyDate}
          earlyBirdNumOfSeats={this.state.earlyBirdNumOfSeats}
          selectedSeats={this.state.selectedSeats}
          allRoutesInfo={this.props.allRoutesInfo}
          dealStartTimeInHours={this.state.dealStartTimeInHours}
          startDealOccupancyThreshold={this.state.startDealOccupancyThreshold}
          stopDealOccupancyThreshold={this.state.stopDealOccupancyThreshold}
          // earlyBirdThresholdDays={this.state.earlyBirdThresholdDays}
          onApplicableDaysChange={this.onApplicableDaysChange}
          onExcludedDateChange={this.onExcludedDateChange}
          onExcludedFocusChange={this.onExcludedFocusChange}
          onDiscountTypeChange={this.onDiscountTypeChange}
          onStartFocusChange={this.onStartFocusChange}
          onEndFocusChange={this.onEndFocusChange}
          onStartDateChange={this.onStartDateChange}
          onEndDateChange={this.onEndDateChange}
          onInputFieldChange={this.onInputFieldChange}
          onDealStartTimeInHoursChange={this.onDealStartTimeInHoursChange}
          // onSourceInputChange={this.onSourceInputChange}
          onSourceItemSelect={this.onSourceItemSelect}
          // onDestinationInputChange={this.onDestinationInputChange}
          onDestinationItemSelect={this.onDestinationItemSelect}
          onSearchClick={this.onSearchClick}
          onSearvicesSelection={this.onSearvicesSelection}
          onCreateDealClick={this.onCreateDealClick}
          onRemoveExculdedDate={this.onRemoveExculdedDate}
          onCancelClick={this.onCancelClick}
          onDealTypeChange={this.onDealTypeChange}
          startDateRangeChecker={this.startDateRangeChecker}
          endDateRangeChecker={this.endDateRangeChecker}
          excludeDateRangeChecker={this.excludeDateRangeChecker}
          onServiceOptionChange={this.onServiceOptionChange}
          onAllRoutesSelectionChange={this.onAllRoutesSelectionChange}
          onJourneyDateChange={this.onJourneyDateChange}
          onJourneyDateFocusChange={this.onJourneyDateFocusChange}
          journeyDateRangeChecker={this.journeyDateRangeChecker}
          fetchCities={this.fetchCities}
          selectSeatHandler={this.selectSeatHandler}
          sourceCityData={this.props.sourceCityData}
          destCityData={this.props.destCityData}
          seatMap={this.props.seatMap}
          seatMapError={this.props.seatMapError}
          setShowViaRoutesWindow={this.setShowViaRoutesWindow}
          showViaRoutesWindow={this.state.showViaRoutesWindow}
          currentViaRoutes={this.state.currentViaRoutes}
          selectedServiceRouteName={this.state.selectedServiceRouteName}
          selectedServiceBusType={this.state.selectedServiceBusType}
          selectedServiceTime={this.state.selectedServiceTime}
          inventoryRefreshCheckbox={this.state.inventoryRefreshCheckbox}
          onInventoryRefreshCheckBox={this.onInventoryRefreshCheckBox}
          selectAllClicked={this.selectAllClicked}
          clearAllClicked={this.clearAllClicked}
          seatSelected={this.state.seatSelected}
          setReturnTripServicesList={this.setReturnTripServicesList}
        />}
        <div className="col-xs-3" />
      </div>
    )
  }
}

const mapStateToProps = store => ({
  allRoutesInfo: store.userInfoReducer.allRoutesInfo,
  dealData: store.dealsReducer.dealData,
  operatorRoutes: store.dealsReducer.operatorRoutes,
  routeServices: store.dealsReducer.routeServices,
  sourceCityData: store.dealsReducer.sourceCityData,
  destCityData: store.dealsReducer.destCityData,
  seatMap: store.dealsReducer.seatMap,
  selectedSeats: store.dealsReducer.selectedSeats,
  seatMapError: store.dealsReducer.seatMapError,
  metaDetails: store.dealsReducer.metaDetails,
  merchantId: store.dashboardReducer.merchantId,
  servicesDataList: store.dealsReducer.servicesDataList,
  seatSelected: store.dealsReducer.seatSelected,
  dynamicSeatData: store.dealsReducer.dynamicSeatData,
})

const mapDispatchToProps = dispatch => ({
  getOperatorRoutes: () => dispatch(actions.getOperatorRoutes()),
  fetchDealData: (dealId, isEditCase) => dispatch(actions.fetchDealData(dealId, isEditCase)),
  fetchServices: (query, merchant, addReturnTripDeal, isReverseRouteClicked) => dispatch(actions.fetchServices(query, merchant, addReturnTripDeal, isReverseRouteClicked)),
  fetchSeatLayout: (serviceData, metaDetails) => dispatch(actions.fetchSeatLayout(serviceData, metaDetails)),
  createDeal: (data, merchantId, callback) => dispatch(actions.createDeal(data, merchantId, callback)),
  updateDeal: (data, callback) => dispatch(actions.updateDeal(data, callback)),
  clearDealData: () => dispatch(actions.clearDealData()),
  fetchCities: (queryStr, fieldType) => dispatch(actions.fetchCities(queryStr, fieldType)),
  fetchDealList: () => dispatch(actions.fetchDealList()),
  // getAllRoutesInfo: () => dispatch(actions.getAllRoutesInfo())
})

CreateEditDeal.propTypes = {}

export default connect(mapStateToProps, mapDispatchToProps)(CreateEditDeal)